import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import { styled } from "@mui/material/styles";
import { TableRow, Theme } from "@mui/material";
import { palettes } from "../themes/palletes";

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.common.white,
    position: "sticky",
    top: 0,
    zIndex: 100,
    "&:not(:last-child)::after": {
      content: '""',
      position: "absolute",
      top: "30%",
      bottom: "30%",
      left: "100%",
      transform: "translateX(-50%)",
      height: "40%",
      width: "1px",
      backgroundColor: theme.palette.common.white,
    },
    whiteSpace: "normal", // Allow wrapping
    wordWrap: "break-word", // Break the word if it's too long
    overflowWrap: "break-word",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    borderRadius: 0,
    border: "none",
    // color: "inherit",
  },
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: palettes.$textLightSubtle,
  },
  "&:nth-of-type(even)": {
    backgroundColor: "#ffffff", // or theme.palette.common.white
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export const StyledTableHeader = styled(TableHead)(({ theme }) => ({
  "& th": {
    color: theme.palette.common.white,
    fontWeight: "600",
  },
}));

export const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  borderRadius: "12px 12px 0 0",
  overflow: "hidden",
  height: `100%`,
  overflowY: "auto",
  overflowX: "auto",
}));

export const StyledTableBody = styled(TableBody)(({ theme }) => ({
  maxHeight: "300px",
  overflowY: "auto",
}));

export const pagination = {
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  maxWidth: "220px",
  overflowX: "auto",
  whiteSpace: "nowrap",
  paddingX: "10px",
  "&::-webkit-scrollbar": {
    display: "none",
  },
  msOverflowStyle: "none",
  scrollbarWidth: "none",
};

export const paginationTotal = {
  position: "absolute",
  right: "20px",
  textAlign: "center",
  fontSize: "12px",
  fontWeight: "600",
  color: "primary.main",
};

export const paginationItem = (isSelected: boolean, theme: Theme) => ({
  marginX: "3px",
  width: "28px",
  height: "28px",
  border: isSelected ? `1px solid ${theme.palette.primary.light}` : "none",
  backgroundColor: isSelected ? theme.palette.primary.main : "transparent",
  borderRadius: "50%",
  color: isSelected ? "white" : theme.palette.primary.main,
  fontWeight: "600",
  fontSize: "12px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  minWidth: "28px",
  maxWidth: "28px",
  flexShrink: 0,
  cursor: "pointer",
  "&:hover": {
    backgroundColor: isSelected
      ? theme.palette.primary.light
      : theme.palette.primary.light,
    color: "white",
  },
});
